import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { leftBarData } from './LeftBarData'
import { Link } from 'react-router-dom'
import "./LeftBar.css"

export default function LeftBar()
{
    return (
        <>
            <div class="leftbar">
                <ListGroup>
                    {leftBarData.map((item, index) => (
                        <ListGroupItem>
                            <Link to={item.url}>{item.name}</Link>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            </div>
        </>
    )
}
